<div class="container-fluid" [ngClass]="usuario.retorno.aparencia">
    <div style="margin-top: 20px;">
        <ul class="breadcrumb">
            <li><strong>Onde estou:</strong></li>
            <li class="active">
                <span id="lblSubMenu"><b>{{ tituloFuncionalidade }}</b></span>
            </li>
        </ul>
        <div class="clearfix">
            <div class="pull-right subfrotas-botoes">

                <button class="btn btn-primary btn-primary-negativo" (click)="exportTable('xlsx')"
                    title="Realiza a exportação da consulta no formato Excel."><i
                        class="fa fa-file-excel-o"></i>Excel</button>
            </div>
        </div>
        <div class="filtroDinamico">
            
        </div>
        <div class="lista-container">
            <app-extended-mat-table id="tblRelatorio" [columns]="columns" [dataSource]="dataSource" [parent]="this" [validaCorLinha]="columnRowData"></app-extended-mat-table>
        </div>
    </div>
</div>